import { connect } from 'react-redux';

import CanvasPublishForm from './CanvasPublishForm';

function mapStateToProps(state, ownProps) {
  const { canvasEditor } = state;
  return { canvasData: canvasEditor };
}

function mapDispatchToProps(dispatch) {
  return {
    clearCanvas: () => dispatch({ type: 'CE_CLEAR' }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CanvasPublishForm);



// WEBPACK FOOTER //
// ./src/components/CanvasPublish/CanvasPublishPageContainer.js